
import React from 'react';
import { Helmet } from 'react-helmet-async';

export function PerformanceOptimizer() {
  return (
    <Helmet>
      {/* Preload critical fonts */}
      <link 
        rel="preload" 
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" 
        as="style"
        onLoad="this.onload=null;this.rel='stylesheet'"
      />
      
      {/* Preload logo */}
      <link 
        rel="preload" 
        href="/images/logo.png" 
        as="image"
        type="image/png"
      />
      
      {/* DNS prefetch for external domains */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//fonts.gstatic.com" />
      <link rel="dns-prefetch" href="//images-na.ssl-images-amazon.com" />
      <link rel="dns-prefetch" href="//m.media-amazon.com" />
      
      {/* Preconnect to critical third-party origins */}
      <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      
      {/* Resource hints for better loading */}
      <meta httpEquiv="x-dns-prefetch-control" content="on" />
      
      {/* Core Web Vitals optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
      
      {/* Theme and color scheme */}
      <meta name="theme-color" content="#3B82F6" />
      <meta name="color-scheme" content="light dark" />
      
      {/* Performance hints */}
      <link rel="preconnect" href="https://www.amazon.com" />
      <link rel="dns-prefetch" href="//www.amazon.com" />
    </Helmet>
  );
}
